/* global $ */
import Events from './Events'
import modalHtml from './Modal.html'
import Mustache from 'mustache'

class Manager{
  
    repository= {
        htmlResources:[],
        pageClasses:[]
    }
    lastRequest= 0
    pageStack= []
    events= new Events(['show','hide','unload'])
    authTokenKey= 'authToken'


    addPageClass( id, clss ){ this.repository.pageClasses[id]= clss }
    getPageClass( id ){ return typeof this.repository.pageClasses[id] !== 'undefined' ? this.repository.pageClasses[id] : false }

    addHtmlResource( id, html ){ this.repository.htmlResources[id]= html }
    getHtmlResource( id ){ return typeof this.repository.htmlResources[id] !== 'undefined' ? this.repository.htmlResources[id] : false }

    getAuthToken(){ return window.localStorage.getItem( this.authTokenKey ) }
    setAuthToken( token ){ window.localStorage.setItem( this.authTokenKey, token ) }
    clearAuthToken(){ window.localStorage.removeItem( this.authTokenKey ) }

    renderPageHtml( html, modal ){ 
        if ( modal ) window.document.getElementById( 'modals' ).innerHTML= Mustache.render(modalHtml, {html: html})
        else window.document.getElementById( 'pageContainer' ).innerHTML= html 
    }

    removeModals(){ window.document.getElementById( 'modals' ).innerHTML = '' }

    getCurrPage(){
        if ( this.pageStack.length > 0 ) return this.pageStack[ this.pageStack.length - 1 ].page
        else return false
    }

    open( id, params, ret ){ 
        let options={save: true, modal: false}
        if ( ret ) options.ret= ret
        this.loadPage( id, params, options ) 
    }
    openModal( id, params, ret ){ 
        let options={save: true, modal: true}
        if ( ret ) options.ret= ret
        this.loadPage( id, params, options)
    }
    switchTo( id, params ){ this.loadPage( id, params, {save: false, modal: false} ) }
    /** options: 
     *  save (bool): si la página actual la savamos en la pila
     *  ret (fn): callback de retorno cuando se recupere la página de la pila. La enlazamos con la página correspondiente (bind)
     *  modal (bool): si la página que vamos a cargar la cargamos de forma modal. (mantenemos la página actual y esta la montamos en modals con su backdrop)
     */
    loadPage( id, params, options ){
        let page, pageClass, pageHtml
        let stackEntry

        if ( pageClass= this.getPageClass( id ) ){
            page= new pageClass( params )

        } else if ( pageHtml= this.getHtmlResource( id ) ) {
            pageClass= this.getPageClass( 'staticHtml' )
            page= new pageClass( pageHtml, params )

        } else {
            console.log(`Error. No se encuentra la página '${id}'`)
            return false
        }
        page.id= id

        stackEntry= { page: page }
        if ( options.modal ) stackEntry.modal= true
        if ( options.save ){
            if ( typeof options.ret === 'function' ) stackEntry.ret= options.ret
            if (! options.modal ) this.events.fires( 'hide', null, this.getCurrPage() )
            this.pageStack.push( stackEntry )

        } else {
            this.events.fires( 'unload', null, this.getCurrPage() )
            this.pageStack[ this.pageStack.length ]= stackEntry
        
        }

        // todo: lanzar algo si la página tiene algo que hacer antes de generar el html (usamos el constructor)
        this.renderPageHtml( page.html(), options.modal )
        this.events.fires( 'show', null, page )
        
        
        return true

    }

    returns(){
        let stackEntry, page
        if ( this.pageStack.length > 1 ){
            this.events.fires( 'unload', null, this.getCurrPage() )
            stackEntry= this.pageStack.pop()
            page=this.getCurrPage()
            if ( stackEntry.modal ) {
                this.removeModals()
                if ( stackEntry.ret ) stackEntry.ret.apply( page, this.getParams(arguments, 0) )

            } else {
                this.renderPageHtml( page.html() )
                if ( stackEntry.ret ) stackEntry.ret.apply( page, this.getParams(arguments, 0) )
                this.events.fires( 'show', null, page )
            }

        } else console.log( 'No more page to return' )


    }

	request( type, name, params ){
		var showErrors= true
		var dfd= $.Deferred()
		var data= {}
		var self= this

		data.name= name
		data.params= JSON.stringify( params )

		var url= `/api/request.php/${type}`
		var token= this.getAuthToken()

		var requestId= ++this.lastRequest
//		if ( 'onRequestStart' in _.app) _.app.onRequestStart( requestId, url, data, new Date() )

		$.ajax( url,{
			method: 'POST'
			, data: data
			, headers: token ? { Authorization: `Bearer ${token}` } : {}
		}).done( function( response, status, xhr ){
			var error
			
//			if ( 'onRequestEnd' in _.app ) _.app.onRequestEnd( requestId, new Date() ) 
			try { 
				error= false;
				response= JSON.parse( xhr.responseText );
			} catch (e) { 
				error= true;
				response= {error: 3, errorMsj: 'Error en la respuesta en request/' + type + ' ' + name + ' Se esperaba un JSON.' };
			}
			if ( error ) dfd.reject( response )
            else dfd.resolve( response )

		}).fail( function( xhr, status, error ){
			var response
			// Cuando se produce un error lógico aunque falle la respuesta a la request, la respuesta trae el mensaje de error

//			if ( 'onRequestEnd' in _.app ) _.app.onRequestEnd( requestId, new Date() )

			if ( xhr.status === 401 ){
				self.clearAuthToken()
				self.switchTo( 'Login' )
			}

			// Error por defecto, si no hay conexión con el servidor
			response= {error: 4, errorMsj: 'Error en en request ' + type + ' ' + name + ' El servidor no responde.' }
			try {
				//Error logico devuelto por el servidor.
				if ( xhr.responseText ) response= JSON.parse( xhr.responseText )
			} catch (e) {
				//Cuando el servidor responde con un mensaje que no es json.
				response= {error: 5, errorMsj: 'Error en la respuesta en request/' + type + ' ' + name + ' Se esperaba un JSON.' };
			}
			dfd.reject( response )

		})
		
		return dfd.promise()

	}

    getParams(args, pos){
        let params=[]
        for( let i= pos; i < args.length; i++ ) params.push( args[i] )
        return params
    }

    defaultRoute(){
        let component, method, params
        let currPage= this.getCurrPage()

        if ( currPage ) {
            switch( typeof currPage[ arguments[0] ] ){
    
                case 'function': //_.( 'method', [params] )
        
                    method= arguments[0]
                    params= this.getParams( arguments, 1 )
                    currPage[ method ].apply( currPage, params )
                    break
                    
                case 'object': //( component, method, params )
                
                    component= arguments[0]
                    if( typeof currPage[ component ][ arguments[1] ] === 'function'){
                        method= arguments[1]
                        params= this.getParams( arguments, 2 )
                        currPage[ component ][ method ].apply( currPage[ component ], params )
                        
                    } else {
                        console.log(`ERROR: No se ha encontrado el método ${arguments[1]} para el componente ${arguments[0]} de la pagina ${currPage.id}`)
                    }
                    break
                    
                default:
                    //Si no se ha definido ni como función ni como propiedad, intentamos ejecutar el metodo undefinedCall
                    if (typeof currPage.undefinedCall === 'function'){
                        params= this.getParams( arguments, 0 )
                        currPage.undefinedCall.apply( currPage, params )
                    } else console.log(`ERROR: No se encuentra ${arguments[0]} en la página actual`)
            }

        }
        
    }

}


export default new Manager()